import { fvDate, fvDateUtc } from '@fv/dates'

import type { TrackDateTime } from '../models/track.ts'

export const getTrackEventDate = (dateTime: TrackDateTime) => {
  const dateStr = `${dateTime.date}T${dateTime.time ?? '23:59:59'}`
  return dateTime.isUTC ? fvDateUtc(dateStr).local() : fvDate(dateStr)
}
